import script from "./DataView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataView.vue?vue&type=script&setup=true&lang=ts"

import "./DataView.vue?vue&type=style&index=0&id=c548afce&lang=scss"

const __exports__ = script;

export default __exports__